import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperOverviewMovementPage } from './shopper-overview-movement';

@NgModule({
  declarations: [
    ShopperOverviewMovementPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperOverviewMovementPage),
    TranslateModule.forChild()
  ],
})
export class ShopperOverviewMovementPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview-movement/shopper-overview-movement.module.ts